import moment from 'moment/moment';

class ExpirationHelper {
  static isFarPastExpiration(adjustedExpirationDate, originalExpireDate, withText = false) {
    let error = '';
    if (!adjustedExpirationDate) {
      // no user date yet
      error = 'Date must not be empty';
    } else if (!moment(adjustedExpirationDate, 'YYYY-MM-DD').isValid()) {
      // User date is invalid currently
      error = 'Date is formatted incorrectly';
    }

    let todayAtMidnight = moment().startOf('day');
    let newExpirationDateMidnight = moment(adjustedExpirationDate, 'YYYY-MM-DD').startOf('day');
    let originalExpirationDateMidnight = moment(originalExpireDate, 'YYYY-MM-DD').startOf('day');

    if (todayAtMidnight.diff(newExpirationDateMidnight, 'days') >= 0) {
      // is in the past
      error = 'New expiration date must be in the future';
    } else if (Math.abs(ExpirationHelper.daysAfterExpiration(originalExpireDate)) >= ExpirationHelper.DAYS_TOO_MANY) {
      // original expiration date was too long ago to adjust
      error = 'Current expiration date too old to change';
    } else if (
      Math.abs(originalExpirationDateMidnight.diff(newExpirationDateMidnight, 'days')) > ExpirationHelper.DAYS_TOO_MANY
    ) {
      // new date is too far future/past to work
      error = `New expiration date more than ${ExpirationHelper.DAYS_TOO_MANY} away from current`;
    }

    return withText ? error : !!error; // you're good!
  }

  static daysAfterExpiration(originalExpireDate) {
    return moment().startOf('day').diff(originalExpireDate, 'days');
  }

  static DAYS_TOO_MANY = 365;
}

export default ExpirationHelper;
